var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepper2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#1B76D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2706 16V15.233L12.1513 12.0795C12.4893 11.7102 12.7678 11.3892 12.9865 11.1165C13.2053 10.8409 13.3672 10.5824 13.4723 10.3409C13.5803 10.0966 13.6342 9.84091 13.6342 9.57386C13.6342 9.26705 13.5604 9.00142 13.4126 8.77699C13.2678 8.55256 13.0689 8.37926 12.8161 8.2571C12.5632 8.13494 12.2791 8.07386 11.9638 8.07386C11.6286 8.07386 11.3359 8.14347 11.0859 8.28267C10.8388 8.41903 10.647 8.6108 10.5107 8.85795C10.3771 9.10511 10.3104 9.39489 10.3104 9.72727H9.30469C9.30469 9.21591 9.42259 8.76705 9.65838 8.38068C9.89418 7.99432 10.2152 7.69318 10.6214 7.47727C11.0305 7.26136 11.4893 7.15341 11.9979 7.15341C12.5092 7.15341 12.9624 7.26136 13.3572 7.47727C13.7521 7.69318 14.0618 7.98437 14.2862 8.35085C14.5107 8.71733 14.6229 9.125 14.6229 9.57386C14.6229 9.89489 14.5646 10.2088 14.4482 10.5156C14.3345 10.8196 14.1357 11.1591 13.8516 11.5341C13.5703 11.9062 13.1797 12.3608 12.6797 12.8977L10.7195 14.9943V15.0625H14.7763V16H9.2706Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper2);
export default __webpack_public_path__ + "static/media/stepper-2.77e2709077c48d607d2c4b95e2f2d3f6.svg";
export { ForwardRef as ReactComponent };